export const H4Fields = [
    { identifier: 'font-size-h4', type: 'input', field: 'font-size-h4' },
    { identifier: 'font-weight-h4', type: 'input', field: 'font-weight-h4' },
    { identifier: 'font-color-h4', type: 'input', field: 'font-color-h4' }
]
